import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import './DiscordCtaButton.css';

/**
 * Discord-branded (blurple) CTA button shared by every surface that
 * pushes users toward Discord — the Manuel dialog and the bot page.
 *
 * Props:
 *   - label: button text
 *   - url: destination opened in a new tab
 *   - analyticsEvent: firebase event name logged on click
 *   - analyticsParams: optional event params (e.g. { placement: 'hero' })
 *     so the same event name can be segmented by surface
 */
export function DiscordCtaButton({ label, url, analyticsEvent, analyticsParams }) {
    const handleClick = () => {
        logEvent(getAnalytics(), analyticsEvent, analyticsParams);
        window.open(url, '_blank');
    };

    return (
        <button type="button" className="discordCtaBtn" onClick={handleClick}>
            <img src="/resources/discord.png" alt="" aria-hidden="true" className="discordCtaBtn__icon" />
            <span className="discordCtaBtn__label">{label}</span>
        </button>
    );
}
